import type { VoidFunctionComponent } from 'react';
import * as _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import BulkSelectionBanner from '../../generic/BulkSelectionBanner';
import * as IssuesV2Store from '../../../redux/issuesV2';
import { ignoreOrResolveWordPast } from '../../../utils';

/**
 * IssuesBulkSelectionBanner is shown when all the issues on the
 * current page are selected, and the user is able to decide if they
 * want _every_ issue across all pages.
 */
const IssuesBulkSelectionBanner: VoidFunctionComponent = () => {
  //  State selectors
  const status = useSelector(IssuesV2Store.selectors.getStatus);
  const count = useSelector(IssuesV2Store.selectors.getIssuesOnPageCount);
  const areAllIssuesSelected = useSelector(IssuesV2Store.selectors.getAreAllIssuesSelected);
  const totalIssuesCount = useSelector(IssuesV2Store.selectors.getTotalIssuesForBanner);
  const isEveryIssueOnPageSelected = useSelector(IssuesV2Store.selectors.getIsEveryIssueOnPageSelected);

  const shouldShowBanner = isEveryIssueOnPageSelected || areAllIssuesSelected;

  //  Handlers:
  const dispatch = useDispatch();
  const onSelectAllIssues = () => dispatch(IssuesV2Store.actions.selectAllIssues());
  const onClearSelection = () => dispatch(IssuesV2Store.actions.clearSelection());

  return shouldShowBanner ? (
    <div className="issues-inbox__bulk-selection-banner--container" data-test-id="issues-bulk-selection-banner">
      <BulkSelectionBanner
        itemsNoun="issue"
        pageSize={count}
        totalItemsCount={totalIssuesCount ?? 0}
        areAllItemsSelected={areAllIssuesSelected}
        sectionName={_.capitalize(status === 'ignored' ? `${ignoreOrResolveWordPast()}` : status)}
        onSelectAll={onSelectAllIssues}
        onClearSelection={onClearSelection}
      />
    </div>
  ) : null;
};

export default IssuesBulkSelectionBanner;
